var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-data-table',{attrs:{"dark":_vm.$store.state.isDarkMode,"headers":_vm.checkHeaders,"items":_vm.payments}})],1),_c('v-col',{attrs:{"sm":"12"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }